import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { AccountLevel4Response } from 'src/app/models/account.model';
import { AccountingEntryDataResponse, AccountingEntryRecordResponse, AccountingEntryResponse, AccountingEntryUpdateRequest, EntryUpdateRequest } from 'src/app/models/accounting-entry.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { JournalService } from 'src/app/services/journal.service';

@Component({
  selector: 'app-history-accounting-entries',
  templateUrl: './history-accounting-entries.component.html',
  styleUrls: ['./history-accounting-entries.component.scss']
})
export class HistoryAccountingEntriesComponent implements OnInit {
  search: string = "";
  pagination = {
    total: [],
    filter: [],
    pageSize: 20,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0,
    totalNumber: 0
  }
  startDate = "";
  endDate = "";
  pageSize = 20;
  accountingEntriesObject: AccountingEntryResponse = null;
  seeing: number = null;
  newDescription: string = null;
  accounts: AccountLevel4Response[] = [];
  updateRequest: AccountingEntryUpdateRequest = null;
  editing: { [key: number]: boolean } = {};
  updating: { [key: number]: boolean } = {};
  inputAccount = {
    id: null,
    value: null,
    verified: false,
    required: false,
    message: 'Campo requerido',
    class: 'fa-asterisk',
    color: 'danger',
    data: null,
    filterElements: []
  }
  inputs: { [key: number]: any } = {};
  entryChanged: AccountingEntryUpdateRequest = null;
  modalCreateAccounting = false;

  constructor(
    private journalService: JournalService,
    private toastService: ToastrService,
    private accountService: AccountService
  ) {
    var date = (new Date()).toLocaleDateString('en-CA');
    this.startDate = date;
    this.endDate = date;
  }

  ngOnInit(): void {
    this.getAccountingEntriesByIntervalDate(new Date(this.startDate).getTime(), new Date(this.endDate).getTime(), false);
    this.getAccountsLevel4();
  }

  editAccountV2(entry: any) {
    this.entryChanged = Object.assign(entry, {});
    entry.updateDescription = entry.description;
    entry.entries.forEach((e) => {
      e.updateAccount = e.account;
      this.inputs[e.id] = {
        id: e.id,
        value: e.accountData.displayId + " " + e.accountData.name,
        verified: false,
        required: false,
        message: 'Campo requerido',
        class: '',
        color: '',
        data: null,
        filterElements: this.accounts
      }
    });
    entry.edition = true;
  }

  filterAccounts(inputAccount, entry) {
    inputAccount.filterElements = this.accounts.filter((account) => {
      return account.displayId.includes(inputAccount.value) || account.name.toLowerCase().includes(inputAccount.value.toLowerCase())
    });
    inputAccount.message = "";
    entry.updateAccount = null;
    if (inputAccount.filterElements.length == 0) {
      inputAccount.class = "fa-xmark";
      inputAccount.color = "danger";
      inputAccount.bgColor = "bg-danger-custom";
    } else {
      inputAccount.class = "";
      inputAccount.color = "";
    }
    inputAccount.verified = false;
  }

  selectAccount(accountSelected: AccountLevel4Response, inputAccount, entry) {
    inputAccount.value = accountSelected.displayId + " " + accountSelected.name;
    if (entry.account == accountSelected.id) {
      inputAccount.class = "";
      inputAccount.color = "";
      inputAccount.bgColor = ""
      inputAccount.message = "";
    } else {
      inputAccount.class = "fa-circle text-info";
      inputAccount.color = "info";
      inputAccount.bgColor = "bg-info-custom"
      inputAccount.message = "Cambios en la cuenta";
    }
    entry.updateAccount = accountSelected.id;
  }

  getAccountsLevel4() {
    this.accountService.getAccountsLevel4().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.inputAccount['filterElements'] = this.accounts;
      }
    })
  }

  validateFields() {
    if (this.pageSize && this.startDate && this.endDate) {
      this.getAccountingEntriesByIntervalDate(DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate), false);
    } else {
      this.toastService.error("Debes completar los campos para lograr obtener registros");
    }
  }

  getAccountingEntriesByIntervalDate(startDate: number, endDate: number, currentMonth: boolean) {
    startDate += (6 * 60 * 60 * 1000);
    endDate += (6 * 60 * 60 * 1000);
    this.journalService.searchAccountingEntriesByIntervalDateV2(currentMonth, endDate, startDate, this.pagination.pageIndex * this.pagination.pageSize).subscribe({
      next: (response: ResponseObject) => {
        this.accountingEntriesObject = response.data as AccountingEntryResponse;
        this.pagination.totalNumber = this.accountingEntriesObject.total;
        this.accountingEntriesObject.records.sort(function (a, b) { return a.date - b.date; })
        this.pagination.total = this.accountingEntriesObject.records;
        this.resetPagination();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  showDetail(entry: AccountingEntryRecordResponse) {
    if (this.seeing == entry.id) {
      this.seeing = null;
    } else {
      entry.entries.forEach((e) => {
        this.inputs[e.id] = {
          id: e.id,
          value: e.accountData.displayId + " " + e.accountData.name,
          verified: false,
          required: false,
          message: 'Campo requerido',
          class: '',
          color: '',
          data: null,
          filterElements: this.accounts
        }
      });
      this.seeing = entry.id;
    }
  }

  cancelChanges(entry) {
    entry.updateDescription = null;
    entry.entries.forEach((e) => {
      e.updateAccount = null;
    });
    entry.edition = false;
  }

  saveChanges(entry) {
    if (this.updating[entry.id]) {
      return;
    }
    this.updating[entry.id] = true;
    var newAccountingEntry = new AccountingEntryUpdateRequest();
    newAccountingEntry.description = (entry.updateDescription) ? entry.updateDescription : entry.description;
    newAccountingEntry.entries
    entry.entries.forEach((e) => {
      var newEntryAccount = new EntryUpdateRequest();
      var account = e.account;
      if (e.updateAccount) {
        account = e.updateAccount;
      }
      newEntryAccount.entryId = e.id;
      newEntryAccount.account = account;
      newAccountingEntry.entries.push(newEntryAccount);
    });
    this.journalService.updateEntryJournal(entry.id, newAccountingEntry).subscribe({
      next: (response: ResponseObject) => {
        this.updating[entry.id] = false;
        entry.edition = false;
        this.toastService.success("Cambios guardados con exito");
        this.getAccountingEntriesByIntervalDate(new Date(this.startDate).getTime(), new Date(this.endDate).getTime(), false);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  changePageSizePagination() {
    this.validateFields();
  }

  resetPagination() {
    // this.pagination.startElement = this.pagination.pageIndex * this.pagination.pageSize;
    // var temporalLast = this.pagination.startElement + this.pagination.pageSize;
    // this.pagination.lastElement = (temporalLast < this.pagination.totalNumber) ? temporalLast : this.pagination.totalNumber;
    // this.pagination.filter = this.pagination.total;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.accountingEntriesObject.records.filter(entry => {
      return entry.description.toLowerCase().includes(this.search.toLowerCase()) || entry.module.toLowerCase().includes(this.search.toLowerCase())
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.totalNumber = this.pagination.total.length;
  }

  getTotal(entries: AccountingEntryDataResponse[], isCredit: boolean = false) {
    var total = 0;
    entries.forEach((entry) => {
      total += (isCredit) ? entry.credit : entry.debit;
    })
    return total;
  }

}
